module.exports = __webpack_public_path__ + "img/9788989646341.c1f7665d.jpg";